// if we didn't have execjs, we wouldn't need to do this (btoa would solve our problem)
import { PhotoSize } from '@alltrails/shared/types/photos';
import { Photo, PhotoId } from 'types/Photo';
import Base64 from './base64';
import { serverAjaxPromise } from './requests/request_helpers';

export const photoSizeMap: Record<PhotoSize, { fit: 'inside' | 'cover'; dimensions: [number, number] }> = {
  small: { fit: 'inside', dimensions: [100, 100] },
  medium: { fit: 'inside', dimensions: [200, 200] },
  large: { fit: 'inside', dimensions: [500, 500] },
  larger_wide: { fit: 'cover', dimensions: [1080, 700] },
  extra_large: { fit: 'inside', dimensions: [2048, 2048] },
  icon: { fit: 'cover', dimensions: [50, 50] },
  small_square: { fit: 'cover', dimensions: [80, 80] },
  medium_square: { fit: 'cover', dimensions: [120, 120] },
  large_square: { fit: 'cover', dimensions: [160, 160] },
  small_wide: { fit: 'cover', dimensions: [160, 120] },
  large_wide: { fit: 'cover', dimensions: [800, 300] }
};

const NEW_SERVERLESS_ROLLOUT_PERCENTAGE = 10;

export const getPhotoUrl = (id: PhotoId, hash: string, photoSize: PhotoSize): string | undefined => {
  if (!id || !hash) {
    return undefined;
  }

  const settings = photoSizeMap[photoSize];
  const [width, height] = settings.dimensions;
  const { fit } = settings;

  // Warning: Changing this has $$$ implications! Photos are cached on CloudFront using this Base64-encoded
  // object as the key. Cache misses go to Lambda to regenerate photos.
  const imageJson = JSON.stringify({
    bucket: 'assets.alltrails.com',
    key: `uploads/photo/image/${id}/${hash}.jpg`,
    edits: {
      toFormat: 'jpeg',
      resize: {
        width,
        height,
        fit
      },
      rotate: null, // use EXIF orientation
      // jpeg: { mozjpeg: true }, ideally, we'd be able to do this, but doesn't seem to be making a difference
      // the line below is an equivalent of mozjpeg: true
      jpeg: { trellisQuantisation: true, overshootDeringing: true, optimiseScans: true, quantisationTable: 3 }
    }
  });

  const random = Math.floor(Math.random() * 100);
  const subdomain = random < NEW_SERVERLESS_ROLLOUT_PERCENTAGE ? 'images' : 'photos';

  return `https://${subdomain}.alltrails.com/${Base64.encode(imageJson)}`;
};

export function getPhotoUrlsFromApi(subPath: string, perPage = 5, size = PhotoSize.Large) {
  return serverAjaxPromise({
    url: `/api/alltrails/v2/${subPath}/photos`,
    data: {
      per_page: perPage
    },
    resReducer: (data: any) => data.photos.map((photo: Photo) => getPhotoUrl(photo.id, photo.photoHash, size))
  });
}
